import {useQuery} from "react-query";

import {http} from "../../../services/api/restApiClient";
import {HistoryEntry} from "../types";

export const useContentHistory = () => {
  return useQuery(
    ["content_history"],
    async () => {
      const {data} = await http.get<{history: HistoryEntry[]}>(
        "/template-history",
      );
      return data.history;
    },
    {
      refetchOnMount: true,
      refetchInterval: 60000,
    },
  );
};
